export default __webpack_public_path__ + "static/media/words-mark.8434be37.png";